import { Component, inject } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MetaDataService } from '../metadata.service';
import { FAQService } from '../faq.service';
import { NGXLogger } from 'ngx-logger';
import { NgClass, AsyncPipe } from '@angular/common';
import { MarkdownPipe } from '../markdown.pipe';

interface FaqItem {
  question: string;
  answer: string;
  isOpen: boolean;
}

@Component({
    selector: 'tea-shop-fe-frequently-asked-questions',
    templateUrl: './frequently-asked-questions.component.html',
    styleUrl: './frequently-asked-questions.component.css',
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({
                height: '0',
                opacity: '0',
                overflow: 'hidden'
            })),
            state('expanded', style({
                height: '*',
                opacity: '1'
            })),
            transition('collapsed <=> expanded', [
                animate('200ms ease-out')
            ])
        ])
    ],
    imports: [NgClass, AsyncPipe, MarkdownPipe]
})
export class FrequentlyAskedQuestionsComponent {
  private metaDataService = inject(MetaDataService);
  private faqService = inject(FAQService);
  private logger = inject(NGXLogger);

  areAllExpanded = false;
  isLoading = true;
  hasError = false;
  faqs: FaqItem[] = [];

  constructor() {
    this.metaDataService.updateMetadata({
      title: 'Frequently Asked Questions',
      image: '/assets/contact/sencha-logo.png',
    });

    this.faqService.getFAQs().subscribe({
      next: (faqs) => {
        this.faqs = faqs
          .sort((a, b) => a.position - b.position)
          .map(faq => ({
            question: faq.question,
            answer: faq.answer,
            isOpen: false
          }));
        this.isLoading = false;
      },
      error: (error) => {
        this.logger.error('Error loading FAQs:', error);
        this.isLoading = false;
        this.hasError = true;
      }
    });
  }

  toggleAllFaqs(): void {
    this.areAllExpanded = !this.areAllExpanded;
    this.faqs.forEach(faq => faq.isOpen = this.areAllExpanded);
  }

  toggleFaq(faq: FaqItem): void {
    faq.isOpen = !faq.isOpen;
  }
}
